import { useMutation, useQueryClient } from 'react-query';
import axios from 'axios';

const emptyTextExtraction = async (data, setProgress) => {
  let intervalId;
  try {
    setProgress(10);

    intervalId = setInterval(() => {
      setProgress(prev => Math.min(prev + 10, 80));
    }, 1000);

    data.empty_only = 1;

    const res = await axios.post(`/app/textract`, data);

    clearInterval(intervalId);
    setProgress(100);
    return res.data;
  } catch (error) {
    clearInterval(intervalId);
    throw error;
  }
};

export const useExtractEmptyTextMutation = (id, { onMutate, setProgress, onError, onSuccess, onSettled } = {}) => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: data => emptyTextExtraction(data, setProgress),
    onMutate: () => {
      onMutate && onMutate();
    },
    onError: error => {
      onError && onError(error);
    },
    onSuccess: async data => {
      await queryClient.invalidateQueries(['GET_PROJECT_FILES', id]);
      onSuccess && onSuccess(data);
    },
    onSettled: () => {
      onSettled && onSettled();
    }
  });

  return { mutate };
};
